module.exports = __webpack_public_path__ + "static/img/2.be60a86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/2.png
// module id = fpA4
// module chunks = 35